/* Solo Babys: botón propio "Agregar al carrito" en las tarjetas */
(function () {
  function sections() {
    var s = [];
    if (document.querySelector('cart-notification')) s = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    else if (document.querySelector('cart-drawer')) s = ['cart-drawer', 'cart-icon-bubble'];
    else if (document.getElementById('cart-icon-bubble')) s = ['cart-icon-bubble'];
    return s;
  }
  function setState(btn, cls, label) {
    btn.classList.remove('is-loading', 'is-done', 'is-error');
    if (cls) btn.classList.add(cls);
    var t = btn.querySelector('.sb-add__txt');
    if (t && label) t.textContent = label;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.sb-cta');
    var sel = wrap && wrap.querySelector('[data-sb-select]');
    var id = sel ? sel.value : btn.getAttribute('data-variant-id');
    if (!id) return;
    var t = btn.querySelector('.sb-add__txt');
    var original = btn.getAttribute('data-label') || (t ? t.textContent : '');
    btn.setAttribute('data-label', original);
    setState(btn, 'is-loading', 'Agregando…');
    var secs = sections();
    var body = { id: Number(id), quantity: 1 };
    if (secs.length) { body.sections = secs.join(','); body.sections_url = window.location.pathname; }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'error');
        setState(btn, 'is-done', '¡Agregado!');
        var j = res.j;
        var notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (notif && typeof notif.renderContents === 'function' && j.sections) {
          try { notif.renderContents(j); } catch (err) {}
        } else if (j.sections && j.sections['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          var tmp = new DOMParser().parseFromString(j.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b && tmp) b.innerHTML = tmp.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('sb:cart-added', { detail: j }));
        setTimeout(function () { setState(btn, null, original); }, 2200);
      })
      .catch(function (err) {
        setState(btn, 'is-error', 'Intenta de nuevo');
        setTimeout(function () { setState(btn, null, original); }, 2200);
      });
  }, true);
})();

/* Solo Babys: barra fija de compra en celular (página de producto) */
(function () {
  function init() {
    var bar = document.querySelector('[data-sb-sticky]');
    if (!bar) return;
    var form = document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"][id^="product-form"]');
    var submit = form && form.querySelector('[type="submit"][name="add"]');
    if (!form || !submit) return;
    var btn = bar.querySelector('[data-sb-sticky-btn]');
    var priceEl = bar.querySelector('[data-sb-sticky-price]');
    var data = {};
    try { data = JSON.parse(bar.querySelector('[data-sb-sticky-variants]').textContent); } catch (e) {}
    function fmt(cents) {
      var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '$' + n;
    }
    function sync() {
      var input = form.querySelector('input[name="id"]');
      var v = input && data.v && data.v[input.value];
      if (!v) return;
      priceEl.textContent = fmt(v[0]);
      btn.disabled = !v[1];
      btn.textContent = v[1] ? 'Agregar al carrito' : 'Agotado';
    }
    btn.addEventListener('click', function () { if (!btn.disabled) submit.click(); });
    document.addEventListener('change', function () { setTimeout(sync, 80); setTimeout(sync, 700); });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('sb-sticky-on', show);
      }).observe(submit);
    }
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Solo Babys: búsqueda (términos populares) y botón buscar del menú */
(function () {
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-sb-term]');
    if (chip) {
      e.preventDefault();
      var ps = chip.closest('predictive-search, search-form') || document.querySelector('predictive-search');
      var input = ps && ps.querySelector('input[type="search"]');
      if (input) {
        input.value = chip.getAttribute('data-sb-term');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }
      return;
    }
    var open = e.target.closest('[data-sb-open-search]');
    if (open) {
      var summary = document.querySelector('details-modal.header__search summary');
      if (!summary) return;
      e.preventDefault();
      var drawer = open.closest('header-drawer');
      var drawerSummary = drawer && drawer.querySelector('#Details-menu-drawer-container > summary');
      // cerrar el menú con su propia función para que la página no quede bloqueada
      if (drawer && drawerSummary && typeof drawer.closeMenuDrawer === 'function') {
        try { drawer.closeMenuDrawer(e, drawerSummary); } catch (err) {}
      }
      setTimeout(function () { summary.click(); }, 150);
    }
  });
})();
